import { Type } from "@angular/core";

export const ComponentRegistry: Map<string, Type<any>> = new Map();

export function RegisterComponent(key: string) {
  return (type: Type<any>) => {
    ComponentRegistry.set(key, type);
  };
}
